import React, { Fragment, useContext } from 'react';
import FormStructureContext from '../../../context/FormStructureContext';
import { SelectHandle } from '../../../schema/interface';
import { useNumberOfToggle } from '../../../hooks/useNumberOfToggle';
import { styles } from './ToggleSelect.styles';

const ToggleMultiSelect = ({
    options,
    selectedOptions,
    handleToggleOption,
    name,
    min,
    otherOptionValue,
    required,
    handleBlur,
    noAccess
}: SelectHandle) => {
    const { fetchedFormStructure } = useContext(FormStructureContext);
    const { isLong } = useNumberOfToggle({ options });
    const classes = styles({
        rtl: fetchedFormStructure?.presentation?.rtl,
        noAccess,
        isLong
    });

    const onChange = (option: string, el: HTMLElement) => {
        handleToggleOption(option);
        setTimeout(() => {
            el.blur();
        }, 0);
    };
    return (
        <div className={classes.toggleContainer}>
            {options.map((option: string[], index: number) => (
                <Fragment key={index}>
                    <input
                        type="checkbox"
                        name={name}
                        value={option?.[0]}
                        id={`${name}-${option?.[0]}`}
                        onChange={() => {
                            const el = document.getElementById(`${`${name}-${option?.[0]}`}`);
                            onChange(option[0], el);
                        }}
                        checked={!!selectedOptions?.find?.((val) => val[0] === option[0])}
                        required={
                            !selectedOptions?.length && (!!min || (required && !otherOptionValue))
                        }
                        onBlur={handleBlur}
                        disabled={noAccess}
                    />
                    <label htmlFor={`${name}-${option?.[0]}`}>{option[1]}</label>
                </Fragment>
            ))}
        </div>
    );
};

export default ToggleMultiSelect;
